/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.ViewForms";
        class ViewFormsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("ViewFormsWidgetTypeClass.createInstance()");
                    return new ViewFormsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("ViewFormsWidgetTypeClass._storeHtml()");
                    ViewFormsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ViewFormsWidgetTypeClass::constructor");
                if (ViewFormsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/ViewForms/view-forms.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.ViewFormsWidgetTypeClass = ViewFormsWidgetTypeClass;
        class ViewFormsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._eformHolder = null;
                this._iframeHolder = null;
                this._contentPanel = null;
                this._subHeaderDiv = null;
                this._formTitle = null;
                this._loader = null;
                this._formHandler = null;
                this._currentFormName = null;
                this._currentFormId = null;
                this._currentDocId = null;
                this._currentDoc = null;
                // private _currentAfterSubmitAction: AfterEFormSubmitAction = null;
                this._returnHomeEnabled = null;
                this._asUnityForm = null;
                this._asFormEditor = null;
                this._currentUnityFormUrl = null;
                this._useProxyUser = null;
                this._suppressSubHeader = null;
                this._selectionKeyword = null;
                this._currentSelectionValue = null;
                this._errorQueue = [];
                this._allowMultipleDocuments = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this.presentInstance = () => {
                    this._log.info("ViewFormsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = ViewFormsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    let length = this._errorQueue.length;
                    for (let i = 0; i < length; i++) {
                        let msg = this._errorQueue[i];
                        this.addError(msg);
                    }
                    this._eformHolder = this._container.querySelector('#eformHolder');
                    this._iframeHolder = this._container.querySelector('#iframeHolder');
                    this._formTitle = this._container.querySelector('#viewFormsFormName');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._contentPanel = this._container.querySelector('#collapsePanel');
                    this._subHeaderDiv = this._contentPanel.querySelector('.widget__subheader');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#viewFormsWidgetTitle'), 'STR_WPT_FORM');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#viewFormsLoading'), 'STR_WPT_LOADING');
                    let conf = this._config;
                    if (conf.hasOwnProperty('ActivateIntoSlots') && (conf.ActivateIntoSlots != null) && (conf.ActivateIntoSlots.length > 0))
                        this._activateIntoSlots = conf.ActivateIntoSlots;
                    let eformConf = {};
                    if (conf.hasOwnProperty('EFormConfig') && conf.EFormConfig != null) {
                        eformConf = conf.EFormConfig;
                    }
                    this._formHandler = new Widgets.ComponentEFormHandler(this._core, this._eformHolder, this, eformConf, this._formSaved, this._hideLoader, this._showLoader);
                    this._formHandler.present();
                    if (this._errorQueue.length === 0) {
                        if (this._asFormEditor)
                            this._loadDocOrFormTemplate();
                        else
                            this._loadFormTemplate();
                    }
                    this._container.querySelector('#viewFormsReload').addEventListener('click', this._reloadForm);
                    this._type.instanceReady(this.getHandle());
                };
                this._hideLoader = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._hideLoader()");
                    this._core.Functions.hideElement(this._loader);
                };
                this._showLoader = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._showLoader()");
                    this._core.Functions.showElement(this._loader);
                };
                this._reloadForm = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._reloadForm()");
                    this._clearErrors();
                    if (this._asFormEditor) {
                        this._formHandler.checkChangesAndRun(this._loadDocOrFormTemplate);
                    }
                    else if (this._asUnityForm) {
                        this._iframeHolder.src = this._currentUnityFormUrl;
                    }
                    else {
                        this._formHandler.checkChangesAndRun(this._formHandler.reloadForm);
                    }
                };
                this._loadDocOrFormTemplate = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._loadDocOrFormTemplate()");
                    this._core.Functions.hideElement(this._iframeHolder);
                    this._core.Functions.showElement(this._eformHolder);
                    this._searchExistingForm();
                };
                this._searchExistingForm = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._searchExistingForm()");
                    let request = {
                        Name: this._currentFormName,
                        KeywordName: this._selectionKeyword,
                        KeywordValue: this._currentSelectionValue
                    };
                    this._core.Loader.genericServiceCallWithData('/Forms.svc/rest/GetExistingForm', JSON.stringify(request), this._searchResponse, null, this._searchError, this._searchFailed);
                };
                this._searchResponse = (response) => {
                    this._log.info("ViewFormsWidgetInstanceClass._searchResponse()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        if (!this._allowMultipleDocuments && response.Documents.length > 1) {
                            let msg = this._core.Locale.getTranslation("STR_WPT_AMBIGUOUS_SELECTION_MSG") + ": " + response.Documents.length;
                            this.addError(msg);
                            this._hideLoader();
                        }
                        else {
                            this._currentDoc = response.Documents[0];
                            this._currentDocId = this._currentDoc.ItemNum;
                            this._displayExistingForm();
                            // We've found the form, so select it
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                            navEvent.ActivationID = this._currentDocId;
                            navEvent.PrimaryContext = this._currentDoc;
                            navEvent.Slots = this._activateIntoSlots;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no documents found");
                        }
                        this._currentDoc = null;
                        this._currentDocId = null;
                        this._loadForm(this._currentFormName);
                    }
                };
                this._searchError = (url, status, message) => {
                    this._log.info("ViewFormsWidgetInstanceClass._searchError()");
                    this.addError(message);
                    this._hideLoader();
                };
                this._searchFailed = (json) => {
                    this._log.info("ViewFormsWidgetInstanceClass._searchFailed()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._hideLoader();
                };
                this._displayExistingForm = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._displayExistingForm()");
                    this._formTitle.innerHTML = "";
                    if (this._suppressSubHeader) {
                        this._core.Functions.hideElement(this._subHeaderDiv);
                    }
                    else {
                        this._formTitle.innerText = this._currentDoc.Name;
                        this._core.Functions.showElement(this._subHeaderDiv);
                    }
                    let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + this._currentDocId;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at file type: " + this._currentDoc.FileType);
                    }
                    switch (this._currentDoc.FileType) {
                        case "Electronic Form":
                        case "Virtual Electronic Form":
                            this._core.Loader.genericServiceCallTextData(url, this._displayEFormTextDocument, this._eformError);
                            break;
                        default:
                            console.error("file type '" + this._currentDoc.FileType + "' not supported, only 'Electronic Form' and 'Virtual Electronic Form' are supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_INVALID_FILETYPE_MSG") + ": " + this._currentDoc.FileType;
                            this.addError(msg);
                            this._hideLoader();
                            break;
                    }
                };
                this._displayEFormTextDocument = (textData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._displayEFormTextDocument()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    switch (textData.ContentType) {
                        case 'text/html':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("html text data: " + textData.ContentText.substring(0, 500));
                            }
                            this._displayEFormDocument(textData.ContentText);
                            break;
                        default:
                            console.error("viewing of file type '" + this._currentDoc.FileType + "' with content type '" + textData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentDocId;
                            this.addError(msg);
                            this._hideLoader();
                            break;
                    }
                };
                this._eformError = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._eformError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentDocId;
                    this.addError(msg);
                    this._hideLoader();
                };
                this._displayEFormDocument = (formData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._displayEFormDocument()");
                    this._formHandler.showFormDocument(this._currentDocId, formData);
                };
                this._loadFormTemplate = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._loadFormTemplate()");
                    if (this._currentFormName)
                        this._loadForm(this._currentFormName);
                };
                this._loadForm = (formName) => {
                    this._log.info("ViewFormsWidgetInstanceClass._loadForm()");
                    this._showLoader();
                    let safeName = this._core.Functions.safeEncodeURIComponent(formName);
                    if (this._asUnityForm) {
                        this._core.Functions.hideElement(this._eformHolder);
                        this._core.Functions.showElement(this._iframeHolder);
                        this._core.Loader.genericServiceCall('/Forms.svc/rest/GetUnityFormTemplateByName/' + safeName, this._unityFormResponse.bind(this, formName), this._unityFormError.bind(this, formName), this._unityFormFailed.bind(this, formName), false);
                    }
                    else {
                        this._core.Functions.hideElement(this._iframeHolder);
                        this._core.Functions.showElement(this._eformHolder);
                        this._core.Loader.genericServiceCall('/Forms.svc/rest/GetEFormTemplateByName/' + safeName, this._formResponse.bind(this, formName), this._formError.bind(this, formName), this._formFailed.bind(this, formName), false);
                    }
                };
                this._unityFormResponse = (formName, formData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._unityFormResponse()");
                    this._formTitle.innerHTML = "";
                    if (formData.hasOwnProperty('Forms') && formData.Forms.length > 0) {
                        let form = formData.Forms[0];
                        this._currentFormId = form.Id;
                        this._currentFormName = form.Name;
                        this._currentUnityFormUrl = form.Url;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got form: " + form.Name + " - " + form.Id);
                        }
                        if (this._suppressSubHeader) {
                            this._core.Functions.hideElement(this._subHeaderDiv);
                        }
                        else {
                            this._formTitle.innerText = form.Name;
                            this._core.Functions.showElement(this._subHeaderDiv);
                        }
                        if (form.hasOwnProperty('Height') && form.Height > 0) {
                            this._iframeHolder.style.height = form.Height + "px";
                        }
                        this._iframeHolder.src = form.Url;
                        this._hideLoader();
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no forms");
                        }
                        let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + formName;
                        this.addError(msg);
                        this._hideLoader();
                    }
                };
                this._unityFormError = (formName) => {
                    this._log.info("ViewFormsWidgetInstanceClass._unityFormError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + formName;
                    this.addError(msg);
                    this._hideLoader();
                };
                this._unityFormFailed = (formName, formData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._unityFormFailed()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + formName;
                    if (formData.hasOwnProperty('Connection') && formData.Connection.hasOwnProperty('Message') && formData.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + formData.Connection.Message;
                    }
                    this.addError(msg);
                    this._hideLoader();
                };
                this._formResponse = (formName, formData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._formResponse()");
                    this._formTitle.innerHTML = "";
                    if (formData.hasOwnProperty('Forms') && formData.Forms.length > 0) {
                        let form = formData.Forms[0];
                        this._currentFormId = form.Id;
                        this._currentFormName = form.Name;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got form: " + form.Name + " - " + form.Id);
                        }
                        if (this._suppressSubHeader) {
                            this._core.Functions.hideElement(this._subHeaderDiv);
                        }
                        else {
                            this._formTitle.innerText = form.Name;
                            this._core.Functions.showElement(this._subHeaderDiv);
                        }
                        let url = '/GetEFormTemplate.ashx?id=' + form.Id;
                        this._core.Loader.genericServiceCallTextData(url, this._formContentResponse, this._formContentError, this._useProxyUser);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no forms");
                        }
                        let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + formName;
                        this.addError(msg);
                        this._hideLoader();
                    }
                };
                this._formError = (formName) => {
                    this._log.info("ViewFormsWidgetInstanceClass._formError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + formName;
                    this.addError(msg);
                    this._hideLoader();
                };
                this._formFailed = (formName, formData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._formFailed()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + formName;
                    if (formData.hasOwnProperty('Connection') && formData.Connection.hasOwnProperty('Message') && formData.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + formData.Connection.Message;
                    }
                    this.addError(msg);
                    this._hideLoader();
                };
                this._formContentResponse = (textData) => {
                    this._log.info("ViewFormsWidgetInstanceClass._formContentResponse()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    switch (textData.ContentType) {
                        case 'text/html':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("html text data: " + textData.ContentText.substring(0, 500));
                            }
                            this._formHandler.showFormTemplate(this._currentFormName, textData.ContentText);
                            break;
                        default:
                            console.error("viewing of form with content type '" + textData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                            this.addError(msg);
                            this._hideLoader();
                            break;
                    }
                };
                this._formContentError = () => {
                    this._log.info("ViewFormsWidgetInstanceClass._formContentError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                    this.addError(msg);
                    this._hideLoader();
                };
                this._formSaved = (response) => {
                    this._log.info("ViewFormsWidgetInstanceClass._formSaved()");
                    if (response.Forms.length > 0) {
                        let form = response.Forms[0];
                        if (form.Itemnum !== null && form.Itemnum !== undefined) {
                            // Tell everyone what we've done
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.FORM_SUBMITTED);
                            navEvent.ActivationID = form.Itemnum;
                            navEvent.PrimaryContext = form;
                            navEvent.Slots = this._activateIntoSlots;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                    if (this._returnHomeEnabled) {
                        this._core.Navigation.Menu.HomeButton.click();
                        return;
                    }
                    this._clearErrors();
                    if (this._asFormEditor) {
                        this._loadDocOrFormTemplate();
                    }
                    else if (this._asUnityForm) {
                        this._iframeHolder.src = this._currentUnityFormUrl;
                    }
                    else {
                        this._formHandler.reloadForm();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ViewFormsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._returnHomeEnabled = false;
                let conf = config;
                if (conf.hasOwnProperty('Type') && conf.Type === "UnityForm") {
                    this._asUnityForm = true;
                }
                else {
                    this._asUnityForm = false;
                }
                if (conf.hasOwnProperty('UseProxyUser') && conf.UseProxyUser) {
                    this._useProxyUser = true;
                }
                else {
                    this._useProxyUser = false;
                }
                if (conf.hasOwnProperty('SuppressSubHeader') && conf.SuppressSubHeader) {
                    this._suppressSubHeader = true;
                }
                else {
                    this._suppressSubHeader = false;
                }
                if (conf.hasOwnProperty('AllowMultipleDocuments') && conf.AllowMultipleDocuments) {
                    this._allowMultipleDocuments = true;
                }
                else {
                    this._allowMultipleDocuments = false;
                }
                this._asFormEditor = false;
                if (conf.hasOwnProperty('SelectionKeyword') && conf.SelectionKeyword != null && conf.SelectionKeyword.length > 0) {
                    this._selectionKeyword = conf.SelectionKeyword;
                    this._asFormEditor = true;
                    if (this._asUnityForm) {
                        let msg = this._core.Locale.getTranslation("STR_WPT_SELECTION_NOT_FOR_UNITYFORMS_MSG");
                        this._errorQueue.push(msg);
                    }
                    else if (this._core.Context.getArchivePrefillValue(this._selectionKeyword)) {
                        this._currentSelectionValue = this._core.Context.getArchivePrefillValue(this._selectionKeyword);
                    }
                    else {
                        let msg = this._core.Locale.getTranslation("STR_WPT_MISSING_USERVARIABLES_MSG") + ": " + this._selectionKeyword;
                        this._errorQueue.push(msg);
                    }
                }
                if (conf.hasOwnProperty('Form') && conf.Form != null && conf.Form.length > 0) {
                    this._currentFormName = conf.Form;
                }
                else if (this._asFormEditor) {
                    let msg = this._core.Locale.getTranslation("STR_WPT_MISSING_CONFIG_MSG") + ": Form";
                    this._errorQueue.push(msg);
                }
            }
            activate(context) {
                this._log.info("ViewFormsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // no activation for form editor mode
                if (this._asFormEditor)
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.FORM_SELECTED:
                        let instance = this;
                        let loadFormAction = function () {
                            let formCtx = context.PrimaryContext;
                            if (formCtx.Type === "UnityForm") {
                                instance._asUnityForm = true;
                            }
                            else {
                                instance._asUnityForm = false;
                            }
                            if (formCtx.ReturnHome === true) {
                                instance._returnHomeEnabled = true;
                            }
                            else {
                                instance._returnHomeEnabled = false;
                            }
                            instance._loadForm(formCtx.Form);
                        };
                        this._formHandler.checkChangesAndRun(loadFormAction);
                        break;
                }
            }
        }
        ViewFormsWidgetInstanceClass.HtmlData = null;
        Widgets.ViewFormsWidgetInstanceClass = ViewFormsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
